import React from 'react';
import styles from './GrayCard.module.scss';

const GrayCard = ({children}) => (
    <div className={styles.container}>
        {children}
    </div>
)

export default GrayCard;